import React from 'react'
import '../assets/css/services.css'


const Services = () => {
  return (
   <>
      <section id="services">
         <div className="service-container">
            <div className="service-title">
               <h2>Quels sont les services que j'offre</h2>

               <h3>Services</h3>
            </div>
            <div className="service-row ">
            {/* <div className='d-flex flex-row  flew-nowrap'></div> */}
            
               {/* Tests */}
               <div
                  className=" my-service"
                  data-aos="zoom-in-up"
                  data-aos-duration="1500"
               >
                  <div className="ser-back">
                     <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 6.878V6a2.25 2.25 0 012.25-2.25h7.5A2.25 2.25 0 0118 6v.878m-12 0c.235-.083.487-.128.75-.128h10.5c.263 0 .515.045.75.128m-12 0A2.25 2.25 0 004.5 9v.878m13.5-3A2.25 2.25 0 0119.5 9v.878m0 0a2.246 2.246 0 00-.75-.128H5.25c-.263 0-.515.045-.75.128m15 0A2.25 2.25 0 0121 12v6a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 18v-6c0-.98.626-1.813 1.5-2.122" />
                     </svg>
                  </div>
                  <h4 className="webtitle">Tests et Débogage</h4>
                  <p className="service-info">
                     Création et exécution de tests pour garantir le bon fonctionnement.
                     Identification et correction des bugs dans l'applications.
                  </p>
                  {/* <h6 className="learn-more">{service.learn_more}</h6> */}
                  {/* <div class="shadow-icon">
                     <i class="icon"></i>
                  </div> */}
               </div>

               {/* Déploiement */}
               <div
                  className=" my-service"
                  data-aos="zoom-in-up"
                  data-aos-duration="1500"
               >
                  <div className="ser-back">
                     <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 7.5l3 2.25-3 2.25m4.5 0h3m-9 8.25h13.5A2.25 2.25 0 0021 18V6a2.25 2.25 0 00-2.25-2.25H5.25A2.25 2.25 0 003 6v12a2.25 2.25 0 002.25 2.25z" />
                     </svg>
                  </div>
                  <h4 className="webtitle">Déploiement et Maintenance</h4>
                  <p className="service-info">
                     Mise en ligne de l'application.
                     Gestion des mises à jours et optimisation continue de l'application.
                  </p>
                  {/* <h6 className="learn-more">{service.learn_more}</h6> */}
                  {/* <div class="shadow-icon">
                     <i class="icon"></i>
                  </div> */}
               </div>

               {/* Frontend */}
               <div
                  className=" my-service"
                  data-aos="zoom-in-up"
                  data-aos-duration="1500"
               >
                  <div className="ser-back">
                     <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 3v1.5M4.5 8.25H3m18 0h-1.5M4.5 12H3m18 0h-1.5m-15 3.75H3m18 0h-1.5M8.25 19.5V21M12 3v1.5m0 15V21m3.75-18v1.5m0 15V21m-9-1.5h10.5a2.25 2.25 0 002.25-2.25V6.75a2.25 2.25 0 00-2.25-2.25H6.75A2.25 2.25 0 004.5 6.75v10.5a2.25 2.25 0 002.25 2.25zm.75-12h9v9h-9v-9z" />
                     </svg>
                  </div>
                  <h4 className="webtitle">Développement Frontend</h4>
                  <p className="service-info">
                     Creation d'interfaces utilisateur attrayantes et conviviales.
                     Intégration des conceptions en page web interactives. 
                  </p>
                  {/* <h6 className="learn-more">{service.learn_more}</h6> */}
                  {/* <div class="shadow-icon">
                     <i class="icon"></i>
                  </div> */}
               </div>

               {/* Backend */}
               <div
                  className=" my-service"
                  data-aos="zoom-in-up"
                  data-aos-duration="1500"
               >
                  <div className="ser-back">
                     <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M17.25 6.75L22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3l-4.5 16.5" />
                     </svg>
                  </div>
                  <h4 className="webtitle">Développement Backend</h4>
                  <p className="service-info">
                     Conception et mise en place de base de données.
                     Implémentation des règles métier, des algorithmes et de la logique de traitement des données.
                  </p>
                  {/* <h6 className="learn-more">{service.learn_more}</h6> */}
                  {/* <div class="shadow-icon">
                     <i class="icon"></i>
                  </div> */}
               </div>

               {/* Gestion des Services Web */}
               <div
                  className=" my-service"
                  data-aos="zoom-in-up"
                  data-aos-duration="1500"
               >
                  <div className="ser-back">
                     <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M20.893 13.393l-1.135-1.135a2.252 2.252 0 01-.421-.585l-1.08-2.16a.414.414 0 00-.663-.107.827.827 0 01-.812.21l-1.273-.363a.89.89 0 00-.738 1.595l.587.39c.59.395.674 1.23.172 1.732l-.2.2c-.212.212-.33.498-.33.796v.41c0 .409-.11.809-.32 1.158l-1.315 2.191a2.11 2.11 0 01-1.81 1.025 1.055 1.055 0 01-1.055-1.055v-1.172c0-.92-.56-1.747-1.414-2.089l-.655-.261a2.25 2.25 0 01-1.383-2.46l.007-.042a2.25 2.25 0 01.29-.787l.09-.15a2.25 2.25 0 012.37-1.048l1.178.236a1.125 1.125 0 001.302-.795l.208-.73a1.125 1.125 0 00-.578-1.315l-.665-.332-.091.091a2.25 2.25 0 01-1.591.659h-.18c-.249 0-.487.1-.662.274a.931.931 0 01-1.458-1.137l1.411-2.353a2.25 2.25 0 00.286-.76m11.928 9.869A9 9 0 008.965 3.525m11.928 9.868A9 9 0 118.965 3.525" />
                     </svg>
                  </div>
                  <h4 className="webtitle">Gestion des Services Web</h4>
                  <p className="service-info">
                     Conception et mise en place d'API.
                     Intégration des services tiers tels que des systèmes de paiement, des APIs publics ou privés.
                  </p>
                  {/* <h6 className="learn-more">{service.learn_more}</h6> */}
                  {/* <div class="shadow-icon">
                     <i class="icon"></i>
                  </div> */}
               </div>

               {/* Sécurité */}
               <div
                  className=" my-service"
                  data-aos="zoom-in-up"
                  data-aos-duration="1500"
               >
                  <div className="ser-back">
                     <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
                     </svg>
                  </div>
                  <h4 className="webtitle">Optimisation et sécurité</h4>
                  <p className="service-info">
                     Mise en place de mesures de sécurité pour protéger les données et prévenir les vulnérabilités.
                  </p>
                  {/* <h6 className="learn-more">{service.learn_more}</h6> */}
                  {/* <div class="shadow-icon">
                     <i class="icon"></i>
                  </div> */}
               </div>

            </div>
         </div>
      </section>
   </>
  )
}

export default Services